export const handleMessage = (e, self, compare, logPatch) => {
  const results = {};
  if (logPatch) {
    try {
      console.log('Calculating patch diffs', JSON.stringify(Object.keys(e.data), null, 2));
    } catch (error) {
      // Do nothing
    }
  }
  for (const [identityKey, data] of Object.entries(e.data)) {
    try {
      const {
        current,
        previous,
        namespace,
        entityName,
        cacheKey
      } = data;
      const currentSizeBytes = JSON.stringify(current).length;
      if (!previous) {
        results[identityKey] = {
          patchSizeBytes: 0,
          patchSizePct: 0,
          totalSizeBytes: currentSizeBytes
        };
        continue;
      }
      const patch = compare(previous, current);
      if (!patch || !patch.length) {
        results[identityKey] = {
          patchSizeBytes: 0,
          patchSizePct: 0,
          totalSizeBytes: currentSizeBytes
        };
        continue;
      }
      const patchSizeBytes = JSON.stringify(patch).length;
      const patchSizePct = patchSizeBytes / currentSizeBytes;
      if (logPatch) {
        const groupName = `[${namespace}/${entityName}] ${cacheKey}\nPatch size: ${(patchSizePct * 100).toFixed(2)}%`;
        console.groupCollapsed(groupName);
        console.log(JSON.stringify({
          totalSizeBytes: currentSizeBytes,
          patchSizeBytes,
          patchSizePct,
          patch
        }, null, 2));
        console.groupEnd();
      }
      results[identityKey] = {
        patchSizeBytes,
        patchSizePct,
        totalSizeBytes: currentSizeBytes
      };
    } catch (error) {
      results[identityKey] = {
        error: error
      };
    }
  }
  self.postMessage(results);
};